export enum AppRoutes {
  NOT_AUTHORIZED_PAGE = 'not-authorized',
  MODULE_EXECUTOR_ROUTE = 'modules',
  MODULE_GROUPS_ROUTE = 'groups',
  MODULE_GROUPS_ADD_ROUTE = 'add-group',
  MODULE_GROUPS_EDIT_ROUTE = 'edit-group',
  MODULE_LIBRARY_ROUTE = 'library',
  DAG_INPUTS_ROUTE = 'dag-inputs',
  AI_DASHBOARD_ROUTE = 'ai-dashboard',
}
